<header
  id="mainHeader"
  [ngClass]="{join: showJoinBanner && (homeBanner.showJoinBanner$ | async)}"
  [class.is-dashboard]="isDashboard"
  *ngIf="aauSubdomain !== null"
>
  <div class="wrap-header">
    <div class="section-left">
      <!-- <div class="icon-fa-bars" #menuBtn (click)="toggleLeftPanel()" [innerHTML]="IconBars | safe: SafeTypes.html"></div> -->
      <a
        *ngIf="!isLoading && owtmaSubdomain"
        routerLink="/"
        (click)="onLogoClick($event)"
        [ngClass]="{ searchIsOpen: hidePanelsOnOpenSearch }"
        class="logo class-owtma-logo"
      >
        <img src="/assets/img/open-world-tour-gold-transparent.png" alt="Open World Tour" />
      </a>
      <a
        *ngIf="!isLoading && !owtmaSubdomain"
        routerLink="/"
        (click)="onLogoClick($event)"
        [ngClass]="{ searchIsOpen: hidePanelsOnOpenSearch,  'class-aau-logo': aauSubdomain }"
        [innerHTML]="(aauSubdomain ? IconAAUxUventex : IconUventex) | safe : SafeTypes.html"
        class="logo"
      ></a>
      <app-header
        class="wrap-panel"
        [isDiffUrl]="isDiffUrl"
        [aauSubdomain]="aauSubdomain"
        [ngClass]="{ searchIsOpen: hidePanelsOnOpenSearch }"
      ></app-header>

      <app-search
        class="adaptive-only"
        [isDiffUrl]="isDiffUrl"
        [ngClass]="{ fullWidth: hidePanelsOnOpenSearch }"
        (displaySearch)="displaySearch($event)"
      ></app-search>
    </div>
    <div class="section-right">
      <div *ngIf="false" class="filter-mobile" (click)="openFiltersMobile()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
        >
          <path
            d="M0.122688 0.715869C0.328938 0.278369 0.766438 0.000244141 1.25081 0.000244141H14.7508C15.2352 0.000244141 15.6727 0.278369 15.8789 0.715869C16.0852 1.15337 16.0227 1.66899 15.7164 2.04399L10.0008 9.02837V13.0002C10.0008 13.3784 9.78831 13.7252 9.44769 13.894C9.10706 14.0627 8.70394 14.0284 8.40081 13.8002L6.40081 12.3002C6.14769 12.1127 6.00081 11.8159 6.00081 11.5002V9.02837L0.282063 2.04087C-0.0210617 1.66899 -0.0866868 1.15024 0.122688 0.715869Z"
            fill="#FFFFFF"
          />
        </svg>
        <span *ngIf="filtersApplied" class="red-dot"></span>
      </div>
      <div class="hub-management">
        <studio-local-selector
          [hidePanelsOnOpenSearch]="hidePanelsOnOpenSearch"
          [isDiffUrl]="isDiffUrl"
        ></studio-local-selector>
      </div>
    </div>
  </div>
</header>
<!-- 
    <div class="loader main" *ngIf="loaderService.isLoading$ | async;">
      <div class="loader-spinner">
        <img src="../../../../assets/img/loader.svg" alt="" />
      </div>
    </div> -->

<div class="wrap-main">
  <div class="main1">
    <div class="filter" *ngIf="false">
      <app-filter
        [title]="'SPORTS'"
        [maxItems]="8"
        [type]="FilterType.sports"
      ></app-filter>
      <app-filter
        [title]="'LEAGUES'"
        [maxItems]="7"
        [type]="FilterType.leagues"
      ></app-filter>
      <app-filter
        [title]="'COUNTRIES'"
        [maxItems]="4"
        [type]="FilterType.countries"
      ></app-filter>

      <a href="https://www.uventexlabs.com" target="_blank">
        <img class="lef-banner" src="/assets/img/left-add-banner.png" />
      </a>
    </div>

    <div
      *ngIf="aauSubdomain !== null"
      class="right-block"
      [ngClass]="{ 'full-width': !showFilters || isDiffUrl || fullWidth }"
    >
      <app-home-header
        *ngIf="showJoinBanner && (homeBanner.showJoinBanner$ | async)"
      >
      </app-home-header>

      <div
        class="outlet"
        [class.h-100]="isDashboard || isAAUReads"
        [ngClass]="{ 'no-padding': isDashboard || isAAUReads || isAAULookupTool}"
      >
        <router-outlet></router-outlet>
        <ng-template #dialogComponentOutlet></ng-template>
        <ng-template #sidebarComponentOutletRight></ng-template>
        <app-loader></app-loader>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>

<app-mobile-filters-dialog
  *ngIf="isDialogOpen"
  (close)="closeDialog()"
></app-mobile-filters-dialog>

<button
  class="scroll-to-top-btn"
  [class.visible]="showScrollTopButton"
  (click)="scrollToTop()"
  aria-label="Scroll to top"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path opacity="0.6" d="M36.0004 3.21574C39.6203 5.30579 42.6316 8.305 44.7361 11.9165C46.8406 15.5279 47.9655 19.6264 47.9992 23.8062C48.033 27.9859 46.9745 32.102 44.9286 35.747C42.8827 39.392 39.9203 42.4394 36.3346 44.5877C32.749 46.736 28.6644 47.9105 24.4853 47.9951C20.3062 48.0797 16.1775 47.0713 12.5079 45.0699C8.83825 43.0685 5.75496 40.1434 3.56324 36.5842C1.37153 33.025 0.147384 28.955 0.0120004 24.7773L0 23.9997L0.0120004 23.2221C0.146409 19.0773 1.35253 15.038 3.51278 11.4981C5.67302 7.9582 8.71368 5.03843 12.3383 3.02346C15.9629 1.00849 20.0478 -0.0329059 24.1947 0.00079259C28.3416 0.0344911 32.409 1.14214 36.0004 3.21574ZM24.0483 11.9997L23.6571 12.0237L23.4507 12.0621L23.1099 12.1701L22.8387 12.2997L22.6707 12.4029L22.4427 12.5733L22.3035 12.7029L12.7034 22.3029L12.5042 22.5285C12.1312 23.0109 11.9558 23.6172 12.0136 24.2242C12.0714 24.8312 12.3581 25.3935 12.8155 25.7967C13.2729 26.2 13.8666 26.4141 14.4761 26.3955C15.0855 26.3769 15.6651 26.127 16.097 25.6965L21.6003 20.1933V33.5997L21.6171 33.8805C21.6893 34.488 21.9908 35.0449 22.4599 35.4375C22.929 35.8301 23.5303 36.0288 24.1409 35.9929C24.7516 35.9571 25.3255 35.6894 25.7455 35.2446C26.1654 34.7998 26.3996 34.2114 26.4003 33.5997V20.1957L31.9036 25.6965L32.1292 25.8957C32.6116 26.2687 33.2179 26.4441 33.8249 26.3863C34.4319 26.3285 34.9941 26.0418 35.3974 25.5844C35.8007 25.127 36.0148 24.5333 35.9962 23.9239C35.9776 23.3144 35.7277 22.7348 35.2972 22.3029L25.6971 12.7029L25.5003 12.5277L25.2867 12.3741L25.0155 12.2253L24.8211 12.1437L24.5499 12.0621L24.2811 12.0141L24.0459 11.9997H24.0483Z" fill="#9A9A9A"/>
  </svg>
</button>
